var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card",
    class: _vm.$style.container
  }, [_vm._m(0), _c('a-form', {
    staticClass: "mb-4",
    attrs: {
      "form": _vm.form
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['email', {
        rules: [{
          required: true,
          message: 'Please type your email'
        }]
      }],
      expression: "[\n            'email',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please type your email',\n                },\n              ],\n            },\n          ]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "Email"
    }
  })], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', {
        rules: [{
          required: true,
          message: 'Please type new password!'
        }]
      }],
      expression: "[\n            'password',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please type new password!',\n                },\n              ],\n            },\n          ]"
    }],
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "New password"
    }
  })], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password_confirmation', {
        rules: [{
          required: true,
          message: 'Please retype your password.'
        }]
      }],
      expression: "[\n            'password_confirmation',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please retype your password.',\n                },\n              ],\n            },\n          ]"
    }],
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "Retype password"
    }
  })], 1), _c('p', [_c('strong', [_vm._v("Please make sure your password is at least 8 characters long.")])]), _c('a-button', {
    staticClass: "text-center w-100",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submitResetPassword($event);
      }
    }
  }, [_c('strong', [_vm._v("Set new password")])])], 1), _c('router-link', {
    staticClass: "kit__utils__link font-size-16",
    attrs: {
      "to": "/auth/login"
    }
  }, [_c('i', {
    staticClass: "fe fe-arrow-left mr-1 align-middle"
  }), _vm._v(" Back to SignIn ")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-dark font-size-24 mb-4"
  }, [_c('strong', [_vm._v("Reset password")])]);
}]

export { render, staticRenderFns }